import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../../utils/app-settings';
import { Observable } from 'rxjs';
import {
  IGetMetricsResponse,
  IGetLineChartResponse,
  IGetPieChartResponse,
} from '../../interfaces/dashboard.interface';

@Injectable({
  providedIn: 'root',
})

export class DashboardService {
  constructor(private http: HttpClient, private appSettings: AppSettings) {}

  getDashboard(startDate?: string, endDate?: string): Observable<IGetMetricsResponse> {
    let params = new HttpParams();
    
    if (startDate) {
      params = params.set('startDate', startDate);
    }
    
    if (endDate) {
      params = params.set('endDate', endDate);
    }
    
    const url = this.appSettings.dashboard.urls.getDashboard;
    return this.http.get<IGetMetricsResponse>(url, { params });
  }

  getDasboardLine(startDate?: string, endDate?: string): Observable<IGetLineChartResponse> {
    let params = new HttpParams();
    
    if (startDate) {
      params = params.set('startDate', startDate);
    }
    
    if (endDate) {
      params = params.set('endDate', endDate);
    }
    
    const url = this.appSettings.dashboard.urls.getDasboardLine;
    console.log('DashboardService - Haciendo petición Line a:', url, 'con params:', params.toString());
    return this.http.get<IGetLineChartResponse>(url, { params });
  }

  getDasboardPie(startDate?: string, endDate?: string): Observable<IGetPieChartResponse> {
    let params = new HttpParams();
    
    if (startDate) {
      params = params.set('startDate', startDate);
    }
    
    if (endDate) {
      params = params.set('endDate', endDate);
    }
    
    const url = this.appSettings.dashboard.urls.getDasboardPie;
    console.log('DashboardService - Haciendo petición Pie a:', url, 'con params:', params.toString());
    return this.http.get<IGetPieChartResponse>(url, { params });
  }
}
